import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Chip from "@mui/material/Chip";
import { useNavigate } from "react-router-dom";
import type { RemovalRunListItem } from "./useCompetitorLinkRemovalList";
import { CompetitorLinkRemovalLabels } from "./CompetitorLinkRemovalLabels";

export function RunRow(props: { item: RemovalRunListItem }) {
  const { item } = props;
  const navigate = useNavigate();
  const detailPath = `/competitor-link-removals/${item.removalId}/show`;
  const detailHref = `#${detailPath}`;

  const handleRowClick = (event: React.MouseEvent<HTMLElement>) => {
    if (event.ctrlKey || event.metaKey) {
      window.open(detailHref, "_blank", "noopener,noreferrer");
      return;
    }
    void navigate(detailPath);
  };

  const handleAuxClick = (event: React.MouseEvent<HTMLElement>) => {
    if (event.button === 1) {
      event.preventDefault();
      window.open(detailHref, "_blank", "noopener,noreferrer");
    }
  };


  // Строка ведёт на карточку: с клавиатуры её открывают Enter'ом или пробелом,
  // как и мышью.
  const handleRowKeyDown = (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      void navigate(detailPath);
    }
  };

  return (
    <TableRow
      hover
      role="row"
      tabIndex={0}
      sx={{ cursor: "pointer" }}
      onClick={handleRowClick}
      onAuxClick={handleAuxClick}
      onKeyDown={handleRowKeyDown}
    >
      <TableCell>
        <Chip size="small" label={CompetitorLinkRemovalLabels.runStatus(item.status)} />
      </TableCell>
      <TableCell>{CompetitorLinkRemovalLabels.autoRemove(item.autoRemove)}</TableCell>
      <TableCell className="tabular-nums" align="right" sx={{ fontVariantNumeric: "tabular-nums" }}>{item.totalSites}</TableCell>
      <TableCell align="right" sx={{ fontVariantNumeric: "tabular-nums" }}>
        {item.sitesScannedCount} / {item.sitesFailedCount}
      </TableCell>
      <TableCell align="right" sx={{ fontVariantNumeric: "tabular-nums" }}>
        {item.postsFoundCount} / {item.linksFoundCount}
      </TableCell>
      <TableCell align="right" sx={{ fontVariantNumeric: "tabular-nums" }}>
        {item.postsRemovedCount} / {item.linksRemovedCount}
      </TableCell>
      <TableCell>{item.createdByName}</TableCell>
      <TableCell>{new Date(item.createdAt).toLocaleString()}</TableCell>
    </TableRow>
  );
}
